import "@/App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import AutomatizacionIA from "./pages/AutomatizacionIA";
import RespondIOPage from "./pages/RespondIOPage";
import GoogleAdsPage from "./pages/GoogleAdsPage";
import MetaAdsPage from "./pages/MetaAdsPage";
import TikTokAdsPage from "./pages/TikTokAdsPage";
import FunnelsPage from "./pages/FunnelsPage";
import CasosDeExito from "./pages/CasosDeExito";
import Contacto from "./pages/Contacto";
import Marca from "./pages/Marca";
import Render from "./pages/Render";

import AdminLogin from "./admin/AdminLogin";
import AdminProtected from "./admin/AdminProtected";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLeads from "./admin/AdminLeads";
import Studio from "./pages/Studio";
import StudioVideo from "./pages/StudioVideo";
import Planner from "./pages/Planner";

const router = createBrowserRouter([
  // Render canvases (no Layout chrome) — used to export PNGs
  { path: "/render", element: <Render /> },
  // Admin (separate shell - no public navbar/footer)
  { path: "/admin/login", element: <AdminLogin /> },
  {
    element: <AdminProtected />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { path: "/admin", element: <AdminDashboard /> },
          { path: "/admin/leads", element: <AdminLeads /> },
        ],
      },
      // Internal /studio — JWT-protected, hidden from menus, no public chrome.
      { path: "/studio", element: <Studio /> },
      // Internal /studiovideo — same JWT auth, hidden from menus, no public chrome.
      { path: "/studiovideo", element: <StudioVideo /> },
      // Internal /planner — AI content matrix, same JWT auth, hidden from menus.
      { path: "/planner", element: <Planner /> },
    ],
  },
  // Public site
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/automatizacion-ia", element: <AutomatizacionIA /> },
      { path: "/respond-io", element: <RespondIOPage /> },
      { path: "/google-ads", element: <GoogleAdsPage /> },
      { path: "/meta-ads", element: <MetaAdsPage /> },
      { path: "/tiktok-ads", element: <TikTokAdsPage /> },
      { path: "/funnels", element: <FunnelsPage /> },
      { path: "/casos-de-exito", element: <CasosDeExito /> },
      { path: "/contacto", element: <Contacto /> },
      { path: "/marca", element: <Marca /> },
      { path: "*", element: <Home /> },
    ],
  },
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
